/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { getAsyncRequestState } from '../../../reducers/asyncRequests'
import * as actions from '../constants/actions'

export const fetchLogsRequest = getAsyncRequestState(actions.FETCH_LOGS)
export const verifyAccountRequest = getAsyncRequestState(actions.VERIFY_ACCOUNT)
export const setInitialPasswordRequest = getAsyncRequestState(actions.SET_INITIAL_ACCOUNT_PASSWORD)
export const resendEmailVerificationLinkRequest = getAsyncRequestState(
  actions.RESEND_EMAIL_VERIFICATION_LINK,
)
export const resetPasswordRequest = getAsyncRequestState(actions.RESET_PASSWORD)
export const saveBillingDetailsRequest = getAsyncRequestState(actions.SAVE_BILLING_DETAILS)
export const fetchBasePricesRequest = getAsyncRequestState(actions.FETCH_BASE_PRICES)
export const fetchMetricsRequest = getAsyncRequestState(actions.FETCH_METRICS)
export const fetchProfileRequest = getAsyncRequestState(actions.FETCH_PROFILE)
export const authorizeSaasOauthTokenRequest = getAsyncRequestState(actions.FETCH_JWT_TOKEN)
export const fetchDriftJwtRequest = getAsyncRequestState(actions.FETCH_DRIFT_JWT)
